import { numberify } from "../numberify";
import { performanceEntries } from "../performanceEntries";

interface AssetMetrics {
    final_asset_images_count?: number;
    final_asset_images_load?: number;
    final_asset_images_size?: number;
    final_asset_javascript_count?: number;
    final_asset_javascript_load?: number;
    final_asset_javascript_size?: number;
    final_asset_other_count?: number;
    final_asset_other_load?: number;
    final_asset_other_size?: number;
    final_asset_stylesheets_count?: number;
    final_asset_stylesheets_load?: number;
    final_asset_stylesheets_size?: number;
}

/**
 * Get asset metrics
 */
export function assets(): AssetMetrics {
    const metrics = {};
    const entries = performanceEntries({
        type: "resource",
    }) as PerformanceResourceTiming[];

    for (const entry of entries) {
        const type = resourceType(entry);
        add(metrics, type, "count", 1);
        add(metrics, type, "load", entry.duration);
        add(metrics, type, "size", entry.decodedBodySize);
    }

    for (const key in metrics) {
        if (isNaN(metrics[key])) {
            metrics[key] = undefined;
        }
    }

    return metrics;
}

/**
 * Mutating
 */
function add(
    accumulator: Record<string, any>,
    type: string,
    key: string,
    value: number,
): void {
    const field = ["final_asset", type, key].join("_");
    accumulator[field] = accumulator[field] || 0;
    accumulator[field] += numberify(value) || 0;
}
const extensionPattern = /\.(\w{2,5})(?:$|\?.*)/;
type AssetType = "images" | "javascript" | "stylesheets" | "other";
interface TypePattern {
    type: AssetType;
    pattern: RegExp;
}
const typePatterns: TypePattern[] = [
    { type: "images", pattern: /jpe?g|gif|png|webm/i },
    { type: "javascript", pattern: /[m|c]?js/i },
    { type: "stylesheets", pattern: /css/i },
];
const initiators = {
    img: "images",
    image: "images",
    script: "javascript",
};
function get(source, pattern, fallback = "") {
    const match = source.match(pattern);

    return (match && match.pop()) || fallback;
}

function resourceType({
    initiatorType,
    name,
}: PerformanceResourceTiming): AssetType {
    if (Object.hasOwnProperty.call(initiators, initiatorType)) {
        return initiators[initiatorType];
    }
    const extension = get(name, extensionPattern);
    const { type } = typePatterns.find(({ pattern }) =>
        get(extension, pattern),
    ) || { type: "other" };

    return type;
}
